import { httpBaseClient, setupBasicInterceptor } from '@systemeio/util'
import { rollbar } from 'rollbar/instance'

setupBasicInterceptor(rollbar)

httpBaseClient.interceptors.response.use(response => {
  if (response.status === 202 && response.config?.method === 'get') {
    rollbar.info('Unexpected 202 response', response)
  }
  return response
})

export const httpClient = httpBaseClient
